export const AUTH_LOGGED_OUT_SUCCESS = "AUTH_LOGGED_OUT_SUCCESS";
